<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapGetters({
      viewsDict: 'views/dict'
    })
  },
  methods: {
    checkMultiLogin() {
      const vm = this;
      return this.$http.get('/session').then((res) => {
        let { data, code } = res.data;
        let isMulti = code === 4001;
        let isLogout = !data;
        vm.storedUserId = (this.$store.getters['userInfo'] || {}).id;
        this.$store.commit('changeLogin', code === 200 ? data : {});
        if (data && data.id && vm.storedUserId && data.id !== vm.storedUserId) {
          // this.$modal.show('MessageDialog', {
          //   title: '登录状态异常。',
          //   content: '由于您登录了另一个账号，请刷新页面。',
          //   btns: [{ type: 'Ok', content: '刷新页面', className: 'button-Ok' }],
          //   resultHandler: (/* type */) => {
          //     window.onbeforeunload = null;
          //     // window.location.reload();
          //     // window.location.replace('/templates');
          //     this.$store.commit('changeLoginVisible', true);
          //   }
          // });

          let temp = `<div style="color: ##606266;line-height: 1.4;">登录状态异常。</div>
          <div style="color: ##606266;line-height: 1.4;">由于您登录了另一个账号，请刷新页面。</div>`;

          this.$alert(temp, '退出登录提示', {
            dangerouslyUseHTMLString: true,
            callback: (/* action */) => {
              // window.onbeforeunload = null;
              // window.location.assign('/templates?login=true');
              window.location.reload();
            }
          });

          this.$bus.emit('checkLoginResult', 'swap');
          return { type: 'swap' };
        }
        if (isMulti && !data && this.userInfo && this.userInfo.id != null) {
          // this.$modal.show("MessageDialog", {
          //   title: "退出登录提示",
          //   content:
          //     "您的账号所登录的设备已超出数量限制，当前账号已自动退出登录。我们已保存您的当前草稿，重新登录后可在“作品管理-我的草稿”中查看。若存在账号和密码泄露的风险，还请至“个人中心-账号设置”中修改密码。",
          //   btns: ["Close"],
          //   resultHandler: type => {
          //     window.location.assign('/templates?login=true');
          //   }
          // });

          let temp = `<div style="color: ##606266;line-height: 1.4;">监测到您的账号在其他设备上登录，当前账号已自动退出。</div>
          <div style="color: ##606266;line-height: 1.4;">若账号存在账号和密码泄露的风险,还请至“个人中心-账号设置”中修改密码。</div>`;

          this.$alert(temp, '退出登录提示', {
            dangerouslyUseHTMLString: true,
            callback: (/* action */) => {
              // window.onbeforeunload = null;
              // window.location.assign('/templates?login=true');
              this.$store.commit('changeLoginVisible', true);
            }
          });

          this.$bus.emit('checkLoginResult', 'multi');
          return { type: 'multi' };
        }
        if (isLogout) {
          // this.$modal.show('MessageDialog', {
          //   title: '当前您处于未登录状态。',
          //   content: '由于在未登录情况下编辑的草稿不能被保存，还请重新登录后再进行编辑。',
          //   btns: [{ type: 'custom', content: '重新登录' }],
          //   resultHandler: (/* type */) => {
          //     window.onbeforeunload = null;
          //     window.location.assign('/templates?login=true');
          //   }
          // });
          this.$store.commit('changeLoginVisible', true);
          this.$bus.emit('checkLoginResult', 'logout');
          return { type: 'logout' };
        }

        this.$bus.emit('checkLoginResult', '');
        return { type: '' };
      });
    },
    storeRegisterSource(trigger = '') {
      let rName = this.$route.path.slice(1);
      let text = this.viewsDict[rName].text;
      console.log('turbo: storeRegisterSource -> text + \'-\' + trigger', text + '-' + trigger);
      this.$store.commit('sensors/setRegisterSuccessSource', {
        name: text + '-' + trigger
      });
    }
  }
};
</script>
